import { filter } from 'lodash';
import { getSiteName, getSitePhone } from '../../utils/url';

//Construct a single string for the deliery address including the address string and postal code
export const getFormattedAddress = (
  DeliveryAddress,
  DeliveryPostalCode,
  DeliveryState,
  DeliverySuburb
) => {
  let str = '';
  str = DeliveryAddress ? `${DeliveryAddress}` : str;
  /*
   str = DeliveryState ? `${str}, ${DeliveryState}` : str;
   */
  str = DeliverySuburb ? `${str}, ${DeliverySuburb}` : str;
  str = DeliveryState ? `${str}, ${DeliveryState}` : str;
  str = DeliveryPostalCode ? `${str}, ${DeliveryPostalCode}` : str;

  return str;
};

// construct a single string for the lease terms
export const getFormattedLease = (Term, Distance) => {
  let str = '';
  str = Term ? `${Term} Months` : str;
  str = Distance ? `${str} - ${Distance}km` : str;
  return str;
};

const getAnswerFromOptions = (options, answerMap) => {
  return options
    .filter(item => item.value === answerMap)
    .map(item => item.label);
  //   (item, index) => {
  //  if(item.value === answerMap) {
  //    return item.label;
  //  }
  // });
};

export const getFilteredQuestionAnswer = questionList => {
  if(!questionList) return [];
  return questionList.map((obj, index) => {
    const updatedList = {};
    updatedList.Answer = getAnswerFromOptions(
      JSON.parse(obj.InputFieldOptions),
      obj.Answer
    );
    updatedList.Question = obj.Question;
    return updatedList;
  });
  // return questionList;
};

export const formatCurrency = cost => {
  if (cost) {
    return cost.toLocaleString();
  }
};

export const formateSummary = data => {
  const {
    QuoteVehicleOptions,
    NetPrice,
    ExteriorColourCode,
    ExteriorColourDescription,
    RoadsideDescription,
    FuelCardServiceDescription,
    AccidentManagementDescription,
    InsuranceDescription,
    MaintenanceTypeDescription,
    TollDescription,
    TyresIncludedDescription,
    DeliveryAddress,
    DeliveryPostalCode,
    DeliveryState,
    DeliverySuburb,
    DeliveryDate,
    Term,
    Distance,
    CustomerName,
    CustomerContactPhone,
    RegistrationState,
    RegistrationPostalCode
  } = data.Quote;

  const quoteDetail = {
    cost: NetPrice || 0,
    leaseTerms: getFormattedLease(Term, Distance),
    // full summary can be parsed by vehicle details panel
    selectedVehicle: data.Quote,
    selectedColour: {Value:ExteriorColourDescription, Key: ExteriorColourCode},
    // for listing included and optional extras
    includedExtras: filter(QuoteVehicleOptions, option => option.Standard),
    optionalExtras: filter(QuoteVehicleOptions, (option, i) => option.Selected),
    // an array of items for the lease details component
    leaseDetails: [
      getFormattedLease(Term, Distance),
      RoadsideDescription,
      FuelCardServiceDescription,
      AccidentManagementDescription,
      InsuranceDescription,
      MaintenanceTypeDescription,
      TollDescription,
      TyresIncludedDescription
    ],
    // obj for the delivery details panel
    deliveryDetails: {
      address: getFormattedAddress(
        DeliveryAddress,
        DeliveryPostalCode,
        DeliveryState,
        DeliverySuburb
      ),
      name: CustomerName || 'N/A',
      phone: CustomerContactPhone || 'N/A',
      date: DeliveryDate
    },
    registrationState: RegistrationState,
    workflowSummary: data.WorkflowSummary || null,
    //duplicating the same prop so that we can utlize on the cached data set from reselect -- rather recompute in the Quoteapproal.js
    statusList: data.WorkflowSummary || null,
    status: data.Status || null,
    totalApprovers: data.TotalApprovers || 0,
    currentApprover: data.CurrentApprover || 0
  };

  return {
    ...quoteDetail,
    questionList: data.Questions
  };
};

export const getMessage = status => {
  let message;
  let siteName = getSiteName();
  let contactNumber = getSitePhone();
  console.log('terst');
  switch (status) {
    case statusReference.APPROVED:
      message = 'This quote has now been progressed to be reviewed by other approvers.';
      break;
    case statusReference.DECLINED:
      message = 'This quote will not progress for further review.';
      break;
    case statusReference.ERROR:
      message = `Please contact ${siteName} on <b>${contactNumber}</b> to learn more about Cost Centre changes.`;
      break;
    default:
      message = '';
  }
  return message;
};

export const statusReference = {
  APPROVED: 2,
  DECLINED: 3,
  INPROGRESS: 4,
  ERROR: 999
};

export const statusConfirmList = [
  {
    value: statusReference.DECLINED,
    label: 'Decline quote ?',
    placeHolder: ' Reason for declining quote (optional) ...'
  },
  {
    value: statusReference.APPROVED,
    label: 'Approve quote ?',
    placeHolder: ' Reason for approving quote (optional) ...'
  }
];



// WEBPACK FOOTER //
// ./src/features/corporate-quote/helper.js